export default {
    methods: {
        compareByName(a, b) {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/common/compare-mixin.js